/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/cards-slideshow.js":
/*!**********************************************************!*\
  !*** ./zrc/scripts/sections/homepage/cards-slideshow.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n\nclass CardsSlideshow extends window.HTMLElement {\n  connectedCallback() {\n    this.$swiper = this.querySelector('.cs-swiper');\n    this.initSwiper();\n  }\n  isMobile() {\n    return $(window).width() <= 834 || window.mobileCheck();\n  }\n  initSwiper() {\n    new swiper__WEBPACK_IMPORTED_MODULE_0__.default(this.$swiper, {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.Navigation, swiper__WEBPACK_IMPORTED_MODULE_0__.Mousewheel, swiper__WEBPACK_IMPORTED_MODULE_0__.FreeMode],\n      slidesPerView: 'auto',\n      resistanceRatio: 0,\n      longSwipesRatio: 0,\n      centerInsufficientSlides: true,\n      allowTouchMove: this.isMobile(),\n      navigation: {\n        nextEl: this.$swiper.parentElement.querySelector('.cs-swiper-button.next'),\n        prevEl: this.$swiper.parentElement.querySelector('.cs-swiper-button.prev')\n      },\n      mousewheel: {\n        enabled: !this.isMobile(),\n        forceToAxis: true\n      },\n      freeMode: {\n        enabled: !this.isMobile(),\n        momentumBounce: false\n      }\n    });\n  }\n}\nif (!window.customElements.get('cards-slideshow')) {\n  window.customElements.define('cards-slideshow', CardsSlideshow);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/cards-slideshow.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"cards-slideshow": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/cards-slideshow.js","custom-commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkfantasias_miguel"] = self["webpackChunkfantasias_miguel"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;